import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/spotify_logo.png')
const LOGO = assets.images.about.spotifyLogo

const SpotifyLogo = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default SpotifyLogo
